<template>
  <div v-if="loaded">
    <b-row>
      <b-col lg="12">
        <Mail
          v-if="ack_id == 0"
          ref="mail"
          :emails_list="mandat.emails"
          :attached_objects="object"
          :body="body"
          :subject="subject"
          :appendButtons="[{label : 'Confirmer l\'accusé de réception', params:{send_mail:false}}]"
          :okButton="{label : 'Confirmer avec envoi par mail', params:{send_mail:true}}"
          @close="$emit('close', $event)"
        >
        </Mail>
        <Mail
          v-else
          ref="mail"
          :emails_list="mandat.emails"
          :attached_objects="object"
          :body="body"
          :subject="subject"
          :okButton="{label : 'Envoyer par mail', params:{send_mail:true}}"
          @close="$emit('close', $event)"
        >
        </Mail>
      </b-col>
      <b-col lg="12" class="my-1">
        
        <b-row class="mt-3">
          <b-col lg="12">
            <object
              style="width: 100%; height: 1000px"
              :data="pdfPath"
              type="application/pdf"
            >
            </object>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import documents from "@/services/documents";
import Mail from "@/components/Mail.vue";
export default {
  name: "AssignationMail",
  components: {
    Mail,
  },
  props: {
    mandat_id: [Number, String],
    ack_id: {
      type: [Number, String],
      default: 0
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pdfPath: null,
      mandat: {},
      body: "",
      signature: `Cabinet De Greft

Rue Chantraine 158/021
B-4420 SAINT-NICOLAS

TEL.: 0032 4 254 05 50
FAX: 0032 4 252 22 13
TVA : BE0478434880
IBAN: BE43 3630 4182 2501
BIC: BBRUBEBB`,
      loaded: false,
      subject: "",
      object: [
        {
          object: "Accusé",
          id: this.mandat_id,
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      documents
        .get_single(
          "mandat_ack",
          this.$props.mandat_id
        )
        .then((response) => {
          this.mandat = response.data;
          this.body = this.mandat.body + "\n" + this.signature;
          this.subject = this.mandat.subject;
          this.loaded = true;
          this.refresh()
        });
    },
    refresh() {
      documents
        .getAccusePreviewPDF(this.mandat_id)
        .then((response) => {
          this.pdfPath = "data:application/pdf;base64," + response.data + "#zoom=100";
        });
      
    },
  },
};
</script>

<style lang="scss" scoped>
</style>